import { useEffect } from "react";

import { useGetUser } from "@/users/v3";

const STORAGE_KEY = "gtm_account_login_event_triggered";

const useTrackGtmAccountLogin = () => {
  const { data: user, loading } = useGetUser();

  useEffect(() => {
    if (loading || user?.roles.includes("student")) {
      return;
    }

    // Ensure we're in the browser
    if (typeof window === "undefined") {
      return;
    }

    if (!user?.is_authenticated) {
      // Remove login event triggered value so it can be triggered again
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    const eventTriggered = localStorage.getItem(STORAGE_KEY) === "true";

    if (eventTriggered) {
      return;
    }

    // Google conversion event tracking
    window.dataLayer?.push({
      event: "account_login",
    });

    // Prevent double tracking
    localStorage.setItem(STORAGE_KEY, "true");
  }, [loading, user?.is_authenticated, user?.roles]);
};

export default useTrackGtmAccountLogin;
